"use strict";
var directives = angular.module('paginationDirective', ['templates']);
directives.directive('pagination', [function() {
  return {
    restrict: 'E',
    scope: {
      page: '=page',
      totalItems: '=totalitems',
      perPage: '=perpage',
      setPageParent: '&?setPage'
    },
    templateUrl: "common/templates/pagination.ng.html",
    replace: true,
    controller: function($scope) {
      $scope.setPage = function(page) {
        $scope.page = page;
        if (typeof $scope.$parent.setPage != 'undefined') {
          $scope.$parent.setPage(page);
        }
        if ($scope.setPageParent) {
          $scope.setPageParent({page: page});
        }
      };
      $scope.updateLastPage = function() {
        $scope.lastPage = Math.ceil($scope.totalItems / $scope.perPage);
      };
      $scope.canDisplay = function(page) {
        if (page >= 1 && page <= $scope.lastPage) {
          return true;
        } else {
          return false;
        }
      };
      $scope.$watchGroup(['totalItems', 'perPage'], function() {
        $scope.updateLastPage();
      });
      var init = function() {
        $scope.updateLastPage();
      }();
    },
    link: function($scope, element, attr) {}
  };
}]);
module.exports = directives;
